/*
 * @Descripttion:
 * @Author: 黄佳鑫
 * @Date: 2025-07-11 16:18:03
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2026-01-14 13:23:21
 */
import { useReducer, useEffect, useState, useRef } from 'react'
import moment from 'moment'
import { imgFile } from '../../modules/goodsdetailmodules/uploadimg'
import { fileFile } from '../../modules/goodsdetailmodules/uploadfiles'
import { Form, message } from 'antd'
import {
  GetLocalStorage,
  MaterialType,
  getFeeText,
  getSupplierId,
  isResponseCodeSuccess,
  formatterPrice,
} from '../../tools/util'
import {
  GET_ERP_PRODUCTCHILD_ADD_REQUIRED,
  // GET_GH03_CATEGORY,
  GET_MARKUP_TEMPCODE,
} from '../../api/MaterialApi'
import {
  ExtendedInfo,
  POST_SAVE_MATERIAL_REPORT,
  POST_SUMBIT_MATERIAL_REPORT,
  QualityList,
  POST_SUBMIT_MATERIAL_REPORT_NEW,
  POST_STORAGE_NEW_MATERIAL,
  ReportFieldConfigVO,
} from '../../api/reportApi'
import { history, useTypedSelector } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { delTabsAction } from '../../modules/authtoken'
import { delRouterAction } from '../../modules/routerModules'
import {
  PlatformField,
  // setLocalCategoryInfoAction,
} from '../../modules/goodsdetailmodules/reducer'
import {
  setModuleDataAction,
  delModuleDataAction,
} from '../../modules/pagecache'
import { userRouter } from '../../route'
import {
  ExternalLinkType,
  toExternalLinkPayload,
} from '@/modules/goodsdetailmodules/externallink'
import { AptitudeFile } from '@/modules/goodsdetailmodules/AptitudeAttach/typing'
import { pick } from 'lodash'
import { useRelateFieldCalc } from '@/hooks/useRelateFieldCalc'
import { reportProjectCategoryAdoptions } from '@/tools/projectCategoryAdopt'
import { PreCheckErrors, usePreCheck } from '@/hooks/usePreCheck'
import {
  preReviewOfMaterialsTypeEnum,
  reportTypeEnum,
} from '@/global/enum/product'
import { getMissingQualityTypeLabels } from '@/modules/goodsdetailmodules/util'

const ACTION_TYPE = {
  CHANGE_PIC: 'change_pic_AT', // 改变预览图
  CHANGE_FILE: 'change_file_AT', // 改变附件
  CHANGE_DETECTION_FILE: 'change_detection_file_AT', // 改变检测报告
  CHANGE_QUALITY_FILE: 'CHANGE_QUALITY_FILE', // 改变质量证明
  CHANGE_DETAIL_PIC: 'change_text_AT', // 改变文本数据
  CHANGE_FIELDLIST: 'change_fieldList', // 改变拓展属性
  CHANGE_PREFIXCODE: 'change_productCode', // 上传图片前缀编码
  SET_CURRENT_PARAM: 'set_current_param', // 设置当前页面参数
  CHANGE_EXPPANSION: 'change_expansion', // 切换默认信息展开隐藏
  CHANGE_RECORD: 'change_record', // 切换操作记录信息展开隐藏
  CHANGE_LOADING: 'change_loading', // loading
  CHANGE_DATA: 'CHANGE_DATA', // 替换所有状态
  SET_BRAND_SALE: 'SET_BRAND_SALE', // 根据品牌是否可售设置商城是否可以修改
  SET_ERP_CODE: 'SET_ERP_CODE',
  CHANGE_DELIVERY: 'CHANGE_DELIVERY', // 改变发货日,
  SET_UNIT_DISABLED: 'SET_UNIT_DISABLED', // 基本单位是否禁用
  SET_MATERIAL_TYPE: 'SET_MATERIAL_TYPE', // 物料类型
  SET_ITEM_LIST: 'SET_ITEM_LIST', // 项目字段
  SET_EXTRACT_VISIBLE: 'SET_EXTRACT_VISIBLE', // 快捷提取外链弹框
  SET_GO_SHIBEI_type: 'SET_GO_SHIBEI_type', // 拾贝弹框类型
  SET_ROUTER_PARAMS: 'SET_ROUTER_PARAMS', // 设置路由参数
  SET_EXTENDED_INFO_LIST: 'SET_EXTENDED_INFO_LIST', // 设置拓展属性列表
  SET_PROJECT_CODE: 'SET_PROJECT_CODE', // 设置项目编码
  SET_QUALITY_DATA_LIST: 'SET_QUALITY_DATA_LIST', // 设置资质图片列表
  SET_QUAL_DOC_FILE_LIST: 'SET_QUAL_DOC_FILE_LIST', // 设置资料附件列表
  SET_FRONTEND_HINT_TEXT: 'SET_FRONTEND_HINT_TEXT', // 设置四级类目前台提示文案
  SET_PRE_CHECK_ERRORS: 'SET_PRE_CHECK_ERRORS', // 设置预审错误信息
  SET_SUBMIT_TYPE: 'SET_SUBMIT_TYPE', // 设置提交类型
}
export interface State {
  pictures: imgFile[]
  productFileList: fileFile[]
  detectionFileList: fileFile[]
  qualityList: fileFile[]
  detailPic: imgFile[]
  fieldList: any[]
  productCode: string // 三级类目前缀编码
  isExpansion: boolean
  isRecord: boolean // 操作记录
  loadingPage: boolean
  brandIsSale: boolean
  code: string
  tempCode: string
  hasDelivery: boolean
  unitDisabled: boolean
  materialType?: MaterialType
  itemsList: PlatformField[]
  extractVisible: boolean // 快捷拾取弹框
  shibeiType: string // 拾取类型
  routerParams: any // 路由参数
  extendedInfoList: ExtendedInfo[]
  projectCode: string
  qualityDataList: QualityList[]
  qualDocFileList: AptitudeFile[] // 资料附件
  frontendHintText: string // 四级类目前台提示文案（选择类目时带出）
  preCheckErrors: PreCheckErrors
  submitType: 'new' | 'old'
}

const defaultHookState: State = {
  pictures: [], // 预览图
  productFileList: [], // 附件
  detectionFileList: [], // 检测报告
  qualityList: [], // 质量证明
  detailPic: [],
  productCode: '',
  fieldList: [],
  // currentparam: {},
  isExpansion: false, // true 展开 false 隐藏
  isRecord: false, // 操作记录
  loadingPage: false,
  brandIsSale: false,
  code: GetLocalStorage('SUPPLIER_CODE'),
  tempCode: '',
  hasDelivery: true,
  unitDisabled: true,
  itemsList: [],
  extractVisible: false,
  shibeiType: 'extract',
  materialType: '1',
  routerParams: {},
  extendedInfoList: [],
  projectCode: '',
  qualityDataList: [],
  qualDocFileList: [],
  frontendHintText: '',
  preCheckErrors: {},
  submitType: 'new',
}
const reducer = (state: State, action: { type: string; value?: any }) => {
  let arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.CHANGE_PIC:
      arr.pictures = action.value
      return arr
    case ACTION_TYPE.CHANGE_FILE:
      arr.productFileList = action.value
      return arr
    case ACTION_TYPE.CHANGE_DETECTION_FILE:
      arr.detectionFileList = action.value
      return arr
    case ACTION_TYPE.CHANGE_QUALITY_FILE:
      arr.qualityList = action.value
      return arr
    case ACTION_TYPE.CHANGE_DETAIL_PIC:
      arr.detailPic = action.value
      return arr
    case ACTION_TYPE.CHANGE_FIELDLIST:
      arr.fieldList = action.value
      return arr
    case ACTION_TYPE.CHANGE_PREFIXCODE:
      arr.productCode = action.value
      return arr
    case ACTION_TYPE.CHANGE_EXPPANSION:
      arr.isExpansion = action.value
      return arr
    case ACTION_TYPE.CHANGE_RECORD:
      arr.isRecord = action.value
      return arr
    case ACTION_TYPE.CHANGE_LOADING:
      arr.loadingPage = action.value
      return arr
    case ACTION_TYPE.CHANGE_DATA:
      arr = action.value
      return arr
    case ACTION_TYPE.SET_BRAND_SALE:
      arr.brandIsSale = action.value
      return arr
    case ACTION_TYPE.SET_ERP_CODE:
      arr.tempCode = action.value
      return arr
    case ACTION_TYPE.CHANGE_DELIVERY:
      arr.hasDelivery = action.value
      return arr
    case ACTION_TYPE.SET_UNIT_DISABLED:
      arr.unitDisabled = action.value
      return arr
    case ACTION_TYPE.SET_MATERIAL_TYPE:
      arr.materialType = action.value
      return arr
    case ACTION_TYPE.SET_ITEM_LIST:
      arr.itemsList = action.value
      return arr
    case ACTION_TYPE.SET_EXTRACT_VISIBLE:
      arr.extractVisible = action.value
      return arr
    case ACTION_TYPE.SET_GO_SHIBEI_type:
      arr.shibeiType = action.value
      return arr
    case ACTION_TYPE.SET_ROUTER_PARAMS:
      arr.routerParams = action.value
      return arr
    case ACTION_TYPE.SET_EXTENDED_INFO_LIST:
      arr.extendedInfoList = action.value
      return arr
    case ACTION_TYPE.SET_PROJECT_CODE:
      arr.projectCode = action.value
      return arr
    case ACTION_TYPE.SET_QUALITY_DATA_LIST:
      arr.qualityDataList = action.value
      return arr
    case ACTION_TYPE.SET_QUAL_DOC_FILE_LIST:
      arr.qualDocFileList = action.value
      return arr
    case ACTION_TYPE.SET_FRONTEND_HINT_TEXT:
      arr.frontendHintText = action.value
      return arr
    case ACTION_TYPE.SET_PRE_CHECK_ERRORS:
      arr.preCheckErrors = action.value
      return arr
    case ACTION_TYPE.SET_SUBMIT_TYPE:
      arr.submitType = action.value
      return arr
    default:
      return state
  }
}

const changepicAction = (params: imgFile[]) => ({
  type: ACTION_TYPE.CHANGE_PIC,
  value: params,
})
const changefileAction = (params: fileFile[]) => ({
  type: ACTION_TYPE.CHANGE_FILE,
  value: params,
})
const changeDetectionfileAction = (params: fileFile[]) => ({
  type: ACTION_TYPE.CHANGE_DETECTION_FILE,
  value: params,
})
const changeQualityfileAction = (params: fileFile[]) => ({
  type: ACTION_TYPE.CHANGE_QUALITY_FILE,
  value: params,
})
const changeDetailPicAction = (params: imgFile[]) => ({
  type: ACTION_TYPE.CHANGE_DETAIL_PIC,
  value: params,
})
const changeFieldlistAction = (params: any[]) => ({
  type: ACTION_TYPE.CHANGE_FIELDLIST,
  value: params,
})
const changePrefixcodeAction = (params: string) => ({
  type: ACTION_TYPE.CHANGE_PREFIXCODE,
  value: params,
})

// 设置展开隐藏
const setExpansionAction = (params: boolean) => ({
  type: ACTION_TYPE.CHANGE_EXPPANSION,
  value: params,
})

// 设置操作记录信息显示隐藏
const changeIsrecordAction = (params: boolean) => ({
  type: ACTION_TYPE.CHANGE_RECORD,
  value: params,
})
// loading
const changeLoadingAction = (params: boolean) => ({
  type: ACTION_TYPE.CHANGE_LOADING,
  value: params,
})

// 重置所有状态
const changeDataAction = (params: State) => ({
  type: ACTION_TYPE.CHANGE_DATA,
  value: params,
})

// 设置商城是否可售能否修改
const changeMallSaleAction = (params: boolean) => ({
  type: ACTION_TYPE.SET_BRAND_SALE,
  value: params,
})

// ERPCODE
const setErpCode = (params: string) => ({
  type: ACTION_TYPE.SET_ERP_CODE,
  value: params,
})

// 改变发货期配置
const changeDeliveryAction = (params: boolean) => ({
  type: ACTION_TYPE.CHANGE_DELIVERY,
  value: params,
})

// 基本单位是否禁用
const setUnitDisabledAction = (params: boolean) => ({
  type: ACTION_TYPE.SET_UNIT_DISABLED,
  value: params,
})

// 物料类型
const setMaterialTypeAction = (params: MaterialType) => ({
  type: ACTION_TYPE.SET_MATERIAL_TYPE,
  value: params,
})

// 项目字段
const setItemListAction = (params: PlatformField[]) => ({
  type: ACTION_TYPE.SET_ITEM_LIST,
  value: params,
})

// 快捷提取外链弹框
const setExtractVisible = (params: boolean) => ({
  type: ACTION_TYPE.SET_EXTRACT_VISIBLE,
  value: params,
})

// 拾贝弹框类型
const setGoShibeiType = (params: string) => ({
  type: ACTION_TYPE.SET_GO_SHIBEI_type,
  value: params,
})

// 设置路由参数
export const setRouterParams = (params: any) => ({
  type: ACTION_TYPE.SET_ROUTER_PARAMS,
  value: params,
})

export const setProjectCodeAction = (params: string) => ({
  type: ACTION_TYPE.SET_PROJECT_CODE,
  value: params,
})
export const setExtendedInfoListAction = (params: ExtendedInfo[]) => ({
  type: ACTION_TYPE.SET_EXTENDED_INFO_LIST,
  value: params,
})

export const setQualityDataListAction = (params: QualityList[]) => ({
  type: ACTION_TYPE.SET_QUALITY_DATA_LIST,
  value: params,
})

// 设置资料附件列表
export const setQualDocFileListAction = (params: AptitudeFile[]) => ({
  type: ACTION_TYPE.SET_QUAL_DOC_FILE_LIST,
  value: params,
})

export const setFrontendHintTextAction = (params: string) => ({
  type: ACTION_TYPE.SET_FRONTEND_HINT_TEXT,
  value: params,
})

export const setPreCheckErrorsAction = (params: PreCheckErrors) => ({
  type: ACTION_TYPE.SET_PRE_CHECK_ERRORS,
  value: params,
})
export const setSubmitTypeAction = (params: 'new' | 'old') => ({
  type: ACTION_TYPE.SET_SUBMIT_TYPE,
  value: params,
})

const useHook = () => {
  const [state, dispatch] = useReducer(reducer, defaultHookState)
  const dispatchRedux = useDispatch()
  const {
    pictures,
    productFileList,
    detectionFileList,
    qualityList,
    fieldList,
    isExpansion,
    detailPic,
    brandIsSale,
    code,
    tempCode,
    hasDelivery,
    itemsList,
    // materialType,
    routerParams,
    extendedInfoList,
    projectCode,
    qualityDataList,
    qualDocFileList,
    frontendHintText,
    preCheckErrors,
    submitType,
  } = state
  const { tabsData } = useTypedSelector((state) => state.authtoken)
  const location = useLocation()
  const { pathname } = location
  const [form] = Form.useForm()
  const [platform_form] = Form.useForm()
  const [changeList, setChangeList] = useState<boolean>(false)
  // 使用 ref 存储最新的 submitType，确保 handleSubmit 能获取到最新值
  const submitTypeRef = useRef<'new' | 'old'>(submitType)
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const dispatchPageCache = useDispatch()
  const [externalLinkList, setExternalLinkList] = useState<ExternalLinkType[]>(
    [],
  )
  const [reportFieldConfigList, setReportFieldConfigList] = useState<
    ReportFieldConfigVO[]
  >([])

  // 缓存数据
  const onCache = () => {
    // 缓存存数据
    const pathName = history.location.pathname
    const formData = form.getFieldsValue()
    const platformsInfo = platform_form?.getFieldsValue() || {}
    const action = setModuleDataAction({
      key: pathName,
      data: {
        pageState: state, // 当前状态
        formData: formData,
        platformsInfo,
        externalLinkData: externalLinkList,
      },
    })
    dispatchRedux(action)
  }

  // ── 关联字段计算逻辑（共享 hook） ──
  const { relateFieldKeySet, handleRelateFieldBlur, relateFieldCalcLoading } =
    useRelateFieldCalc({
      reportFieldConfigList,
      platform_form,
      projectCode,
      onAfterCalc: onCache,
    })

  // 将表单值序列化为可 JSON 存储的数据（DatePicker 的 moment 需要特殊处理）
  const serializeFormValuesForStorage = (values: Record<string, any>) => {
    const result: Record<string, any> = {}
    Object.keys(values || {}).forEach((key) => {
      const value = values[key]
      if (moment.isMoment(value)) {
        result[key] = {
          __type: 'moment',
          value: value.toISOString(),
        }
      } else if (Array.isArray(value)) {
        result[key] = value.map((item) =>
          moment.isMoment(item)
            ? { __type: 'moment', value: item.toISOString() }
            : item,
        )
      } else {
        result[key] = value
      }
    })
    return result
  }

  useEffect(() => {
    const flag = getpagecache()
    const { state } = location as any
    console.log(state, 'state')
    if (flag && !state) {
      form.setFieldsValue(flag.formData)
      platform_form.setFieldsValue(flag.platformsInfo)
      dispatch(changeDataAction(flag.pageState))
      setExternalLinkList(flag.externalLinkData)
      setChangeList(!changeList)
    } else if ((location.state as any)?.type === 'copy') {
      dispatch(setRouterParams(location.state))
      const { platformsInfo, formData, pageState, type, externalLinkData } =
        location.state as any
      if (type === 'copy') {
        setExternalLinkList(externalLinkData)
        form.setFieldsValue(formData)
        platform_form.setFieldsValue(platformsInfo)
        dispatch(changeDataAction(pageState))
        changeUnitDisabled(false)
        getTempCode()
        setChangeList(!changeList)
      }
    } else if (pathname === '/srm/addgoods') {
      changeUnitDisabled(false)
    }

    // 这屎山和结构真无敌了
    if (
      state?.BtnState?.includes('Edit') &&
      !state?.productMdmId &&
      pathname !== '/srm/editgoods'
    ) {
      changeUnitDisabled(false)
    }
    // getGH03Category()
  }, [])

  // 改变图片
  const onChangePic = (pic: imgFile[]) => {
    dispatch(changepicAction(pic))
  }

  // 改变产品资料
  const onChangeFile = (file: fileFile[]) => {
    dispatch(changefileAction(file))
  }

  // 改变检测报告
  const onChangeDetectionfile = (file: fileFile[]) => {
    dispatch(changeDetectionfileAction(file))
  }

  // 改变质量证明
  const onChangeQualityfile = (file: fileFile[]) => {
    dispatch(changeQualityfileAction(file))
  }

  // 改变详情图
  const onChangeDetailPic = (pic: imgFile[]) => {
    dispatch(changeDetailPicAction(pic))
  }

  // 改变拓展属性
  const onChangeFieldlist = (
    param: {
      id: string
      name: string
      types: string[]
      platformCodeAttribute: string[]
      platformCodeLabel: string[]
      platformAbbreviationName: string
    }[],
  ) => {
    dispatch(changeFieldlistAction(param))
  }

  // 上传图片编码
  const onChangeUploadPicCode = (param: string) => {
    dispatch(changePrefixcodeAction(param))
  }

  // 点击操作记录
  const onClickRecord = () => {
    const action = changeIsrecordAction(true)
    dispatch(action)
  }

  // 关闭操作记录
  const onCancelrecord = () => {
    const action = changeIsrecordAction(false)
    dispatch(action)
  }
  // 展开收起
  const onExpansion = () => {
    const action = setExpansionAction(!isExpansion)
    dispatch(action)
  }

  // 切换类目 设置扩展属性 前缀编码
  const onChangeCate = async (
    e: string,
    type?: string,
    _materialCode?: string,
    frontendHintText?: string,
  ) => {
    const id = e
    const resData: any = await GET_ERP_PRODUCTCHILD_ADD_REQUIRED({
      categoryId: id,
      productType: type ?? form.getFieldValue('productType'),
    })
    if (resData.code === 0) {
      onChangeFieldlist(resData.data)
    }
    // 四级类目前台提示文案（选择类目/详情回填时带出）
    dispatch(setFrontendHintTextAction(frontendHintText ?? ''))
  }

  // 设置拓展属性值
  const setFieldList = (fieldNameList: any[]) => {
    const list = fieldNameList.map((item) => ({
      ...item,
      types: item.type,
    }))
    onChangeFieldlist(list)
    // 拓展属性 表单赋值
    fieldNameList.map((item: any) => {
      form.setFieldsValue({
        [item.id]: item.valueType === '1' ? item.enumValueList : item.value,
      })
      return item
    })
  }

  // 获取拓展属性值
  const getFieldList = () => {
    const arr: any[] = []
    fieldList.map((item: any) => {
      const value = form.getFieldValue(item.id)
      arr.push({
        ...item,
        id: item.id,
        valueType: item.valueType || '2',
        enumValueList: item.valueType === '1' ? value || '' : '',
        value: item.valueType !== '1' ? value || '' : '',
        required: item.required,
        multiple: item.multiple || '0',
      })
      return item
    })
    return arr
  }

  // 表单变化
  const onFieldsChange = () => {
    onCache()
  }

  useEffect(() => {
    // 缓存存数据
    onCache()
    // eslint-disable-next-line
  }, [state, externalLinkList])

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 关闭
  const onClickClose = (path?: any) => {
    let newurl = ''
    if (tabsData.length === 0) {
      // 最后一个tabs
      newurl = '/srm/home'
    }
    let delkey = ''
    if (tabsData.length > 0) {
      let param = 0
      tabsData.map((item, index) => {
        if (item.url === pathname) {
          delkey = item.key
          param = index - 1
        }
        return item
      })
      // 排除下标为1的
      const url = param >= 0 ? tabsData[param].url : '/srm/home'
      newurl = url
    }
    // 删除标签 删除对应路由 删除缓存数据 跳转前一个标签页
    dispatchRedux(delTabsAction(delkey))
    dispatchRedux(delRouterAction(delkey))
    dispatchPageCache(delModuleDataAction(pathname))
    if (path) {
      dispatchPageCache(delModuleDataAction(path))
    }
    history.replace(newurl)
  }

  // 控制 loading
  const onChangeLoading = (param: boolean) => {
    const action = changeLoadingAction(param)
    dispatch(action)
  }

  // 重置所有状态
  const reloaddata = (param: State) => {
    const action = changeDataAction(param)
    dispatch(action)
  }

  // 物料详情 表单数据（回填）
  const formatFormFields = (formdata: any) => {
    setMaterialType(formdata.srmProductType)
    onChangeDelivery(
      !formdata.deliveryDay || formdata.deliveryDay === '详询客服'
        ? true
        : false,
    )
    // 主图
    onChangePic(
      formdata.mainUrl?.map((item: any) => {
        const targetIndex =
          item.fullUrl.indexOf(
            '/',
            item.fullUrl.indexOf('/', item.fullUrl.indexOf('/') + 1) + 1,
          ) + 1
        return {
          url: item.fullUrl.substring(targetIndex),
          name: '',
          baseUrl: item.fullUrl.substring(0, targetIndex),
        }
      }),
    )
    // 详情图
    onChangeDetailPic(
      formdata.detailPicList?.map((item: string) => {
        const targetIndex =
          item.indexOf('/', item.indexOf('/', item.indexOf('/') + 1) + 1) + 1
        return {
          url: item.substring(targetIndex),
          name: '',
          baseUrl: item.substring(0, targetIndex),
        }
      }),
    )
    // 产品资料
    onChangeFile(
      formdata.fileList?.map((item: any) => ({
        url: item.fileUrl,
        name: item.fileName,
        baseUrl: item.baseUrl || GetLocalStorage('BASEURL'),
      })),
    )
    // 检测报告
    onChangeDetectionfile(
      formdata.testReportFileList?.map((item: any) => ({
        url: item.fileUrl,
        name: item.fileName,
        baseUrl: item.baseUrl || GetLocalStorage('BASEURL'),
      })),
    )
    // 质量证明
    onChangeQualityfile(
      formdata.certificateOfQuality?.map((item: any) => ({
        url: item.fileUrl,
        name: item.fileName,
        baseUrl: item.baseUrl || GetLocalStorage('BASEURL'),
      })),
    )
    // 扩展属性
    setFieldList(
      formdata.fieldList?.map((item: any) => ({
        ...item,
      })),
    )
    changeItemList(formatFieldForDetail(formdata.projectValueInfoList))
    let remakers: string = formdata.remark ?? ''
    if (formdata.testingFee) {
      remakers = remakers.replace(
        getFeeText('testingFee', formdata.testingFee),
        '',
      )
    }
    if (formdata.packingExpense) {
      remakers = remakers.replace(
        getFeeText('packingFee', formdata.packingExpense),
        '',
      )
    }

    return {
      ...formdata,
      productType: formdata.srmProductType, // 物料类型
      name: formdata.name, // 物料名称
      tempCode: formdata.code, // 编码
      cateName: formdata.cateName, // 类目名
      fourthCateMdmId: formdata.fourthCateMdmId || formdata.cateMdmId, // 类目ID
      brand: `${formdata.brandNameCn}/${formdata.brandNameEn}`, // 品牌
      brandMdmId: formdata.brandMdmId, // 品牌ID
      brandNameCn: formdata.brandNameCn, // 品牌中文名
      brandNameEn: formdata.brandNameEn, // 品牌英文名
      spec: formdata.model, // 型号规格
      baseunitName: formdata.basicUnitName + '/' + formdata.basicUnit, // 基本单位名称
      baseunit: formdata.basicUnit, // 基本单位
      grossweight: formdata.grossWeight, // 毛重
      netweight: formdata.netWeight, // 净重（千克）
      marketprice: formatterPrice(formdata.marketPrice), // 市场价
      mallprice: formatterPrice(formdata.supplyPrice), // 参考供货价
      freight: formdata.isTransferPriceFreightIncluded, // 含运费
      barCode: formdata.barCode, // 条形码
      deliveryday:
        formdata.deliveryDay === '详询客服' ? '' : formdata.deliveryDay, // 发货期
      deliveryDate: formdata.deliveryDay,
      orderQuantity: formdata.moq, // 起订量
      size1: formdata.length, // 长（mm）
      size2: formdata.width, // 宽（mm）
      size3: formdata.height, // 高（mm）
      volume: formdata.volume, // 体积
      remakers, // 描述
      id: formdata.id,
      productMdmId: formdata.productMdmId,
      cateMdmId: formdata.cateMdmId,
      isAssessing: formdata.isAssessing,
      picMatch: formdata.pictureRelationship, // 图片匹配度
      packingExpense: formdata.packingExpense, // 安装费
      testingFee: formdata.testingFee, // 检测费
      externalLinks: toExternalLinkPayload(externalLinkList), // 外部链接
      haltProduction: formdata.isDelisting, // 停产
      taxCategoryCode: formdata.taxCategoryCode, // 税收分类编码
      taxCategoryCodeName: formdata.taxCategoryName, // 税收分类名称
      taxCategoryRate: formdata.taxCategoryRate, // 税率字段 税率
      abbreviation: formdata.taxCategoryAbbr, // 简称
    }
  }

  // 获取基础表单数据（提交）
  const getformatFormFields = async () => {
    // 同时校验主表单和平台表单
    const [formValue, platformFormValue] = await Promise.all([
      form.validateFields(),
      platform_form.validateFields(),
    ])
    // 拓展属性
    const expands = getFieldList()
    // 主图
    const picUrlList = getPicListString()
    // 详情图
    const detailPicUrlList = getDetailPicListString()
    // 产品资料
    const productFiles = getFileListString()
    // 检测报告
    const detectionFiles = getdetectionListString()
    // 质量证明
    const qualityFiles = getQualityList()
    const des = `${getFeeText('testingFee', formValue.testingFee)}${getFeeText(
      'packingFee',
      formValue.packingExpense,
    )}${formValue.remakers ?? ''}`
    return {
      ...pick(formValue, ['picMatch']),
      supplierId: getSupplierId(),
      expands: expands, // 拓展属性
      mainPictures: picUrlList, // 主图
      detailedPictures: detailPicUrlList, // 详情图
      productLiteratures: productFiles, // 产品资料
      reports: detectionFiles, // 检测报告
      certificateOfQualitys: qualityFiles, // 质量证明
      tempCode: formValue.tempCode, // 临时编码
      name: formValue.name, // 商品名称
      cateName: formValue.cateName, // 类目名称
      fourthCateMdmId: formValue.fourthCateMdmId, // 四级类目ID
      brand: formValue.brand, // 品牌
      brandMdmId: formValue.brandMdmId,
      brandNameCn: formValue.brandNameCn || formValue.brand.split('/')[0],
      brandNameEn: formValue.brandNameEn || formValue.brand.split('/')[1],
      model: formValue.spec, // 规格型号
      basicUnit: formValue.baseunit, // 基本单位
      basicUnitName: formValue.baseunitName?.split('/')[0], // 基本单位
      grossWeight: formValue.grossweight, // 毛重
      netWeight: formValue.netweight ? formValue.netweight : '', // 净重（千克）
      marketPrice: formValue.marketprice, // 市场价
      purchasePrice: formValue.mallprice, // 参考供货价
      freight: formValue.freight, // 是否包邮
      barCode: formValue.barCode, // 条形码
      deliveryDate: hasDelivery ? '详询客服' : formValue.deliveryday, // 发货期 hasDelivery为true是详询客服
      orderQuantity: formValue.orderQuantity, // 起订量
      length: formValue.size1, // 长（mm）
      width: formValue.size2, // 宽（mm）
      height: formValue.size3, // 高（mm）
      volume: formValue.volume, // 体积
      des, // 描述
      isMultipleOrder: formValue.isMultipleOrder,
      id: formValue.id ?? '',
      cateMdmId: formValue.cateMdmId ?? '',
      productMdmId: formValue.productMdmId ?? '',
      testingFee: formValue.testingFee, // 含检测费
      packingExpense: formValue.packingExpense, // 含安装费
      haltProduction: formValue.haltProduction, // 停产
      pictureRelationship: formValue.picMatch, // 图片关系
      externalLinks: toExternalLinkPayload(externalLinkList), // 外部链接
      platformDetails: formatFieldForSubmit(itemsList), // 项目信息
      productType: formValue.productType,
      taxCategoryCode: formValue.taxCategoryCode, // 税收分类编码
      taxCategoryName: formValue.taxCategoryCodeName, // 税收分类名称
      taxCategoryRate: formValue.taxCategoryRate, // 税率字段 税率
      taxCategoryAbbr: formValue.abbreviation, // 简称
    }
  }

  const onChangeBrandSale = (params: string) => {
    dispatch(changeMallSaleAction(params === '0' ? true : false))
  }
  // 获取临时编码
  const getTempCode = async (preCode?: string) => {
    const res = await GET_MARKUP_TEMPCODE({
      supplierCode: GetLocalStorage('SUPPLIER_MDM_CODE'),
      supplierId: getSupplierId(),
      preCode,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      dispatch(setErpCode(resData.tempCode))
    }
  }

  // 设置编码
  const setTempCodeFun = (code: string) => {
    dispatch(setErpCode(code))
  }

  // 主图数据处理
  const getPicListString = () => {
    return [...pictures]
  }

  // 详情图数据处理
  const getDetailPicListString = () => {
    return [...detailPic]
  }

  // 产品资料数据处理
  const getFileListString = () => {
    return [...productFileList]
  }

  // 检查报告数据处理
  const getdetectionListString = () => {
    return [...detectionFileList]
  }

  // 获取质量证明url数组
  const getQualityList = () => {
    return [...qualityList]
  }

  // 改变发货期
  const onChangeDelivery = (param: boolean) => {
    dispatch(changeDeliveryAction(param))
  }

  // 基本单位是否禁用
  const changeUnitDisabled = (val: boolean) => {
    dispatch(setUnitDisabledAction(val))
  }

  // 物料类型
  const setMaterialType = (val: MaterialType) => {
    dispatch(setMaterialTypeAction(val))
  }

  // 项目字段
  const changeItemList = (val: PlatformField[]) => {
    dispatch(setItemListAction(val))
  }

  // 提交时格式化项目字段参数
  const formatFieldForSubmit = (list: PlatformField[]) =>
    list.map((item) => ({
      platformName: item.name,
      platformCode: item.code,
      fieldKeyAndValue: item.itemFields.map((child) => {
        const fieldValue = platform_form.getFieldValue(
          `${item.code}_${child.fieldKey}`,
        )
        return {
          fieldKey: child.fieldKey,
          fieldName: child.fieldName,
          fieldValue:
            child.controlType === '5'
              ? (fieldValue as string[])?.join(',')
              : fieldValue,
          rangeList: child.rangeList,
          require: child.require,
          controlType: child.controlType,
        }
      }),
    }))

  // 回填时格式化项目字段
  const formatFieldForDetail = (list: any[]): PlatformField[] =>
    list.map((item) => ({
      name: item.platformName,
      code: item.platformCode,
      itemFields: item.fieldKeyAndValue.map((item: any) => ({
        ...item,
        fieldValue: item.fieldValue === 'null' ? undefined : item.fieldValue,
        fieldValueName:
          item.fieldValueName === 'null' ? undefined : item.fieldValueName,
      })),
      pushRequirements: item.pushRequirements,
    }))

  // 获取GH03类目信息
  // const getGH03Category = async () => {
  //   const res: any = await GET_GH03_CATEGORY()
  //   dispatchRedux(
  //     setLocalCategoryInfoAction({
  //       name: res[0]?.name,
  //       id: res[0]?.id,
  //     }),
  //   )
  //   // 默认值
  //   if (!materialType) {
  //     const defaultMaterialType = cooperateType === '3' ? '2' : cooperateType
  //     defaultMaterialType === '2' &&
  //       form.setFieldsValue({
  //         cateName: res[0]?.name,
  //         fourthCateMdmId: res[0]?.id,
  //       })
  //   }
  // }

  // 快捷拾取弹框打开按钮
  const handleOpenExtractModal = (type: string) => {
    dispatch(setGoShibeiType(type))
    dispatch(setExtractVisible(true))
  }

  // 快捷拾取结果页弹框取消按钮
  const closeExtractModal = () => {
    dispatch(setExtractVisible(false))
  }

  const clickCopy = () => {
    const supRoute = userRouter[1].url
    const formData = form.getFieldsValue()
    const platform = platform_form.getFieldsValue()
    history.replace({
      pathname: `${supRoute}/addgoods`,
      state: {
        type: 'copy',
        platform,
        formData,
        pageState: state,
        externalLinkData: externalLinkList,
      },
    })
    dispatchPageCache(delModuleDataAction(`${supRoute}/addgoods`))
  }

  // 新增、修改、重推提交时，校验平台要求必传的资质图片类型
  const checkRequiredQualityTypes = () => {
    if (
      !reportTypeEnum.isLabelsMatchValue(
        ['商品新增', '商品修改', '商品重推'],
        routerParams.submissionType,
      )
    ) {
      return true
    }
    const missing = getMissingQualityTypeLabels([projectCode], qualityDataList)
    if (missing.length) {
      message.warning(`请上传资质图片：${missing.join('、')}`)
      return false
    }
    return true
  }

  // 点击保存
  async function onSave(type: 'save' | 'submit') {
    try {
      // 格式化表单数据
      const [value, formValue] = await Promise.all([
        platform_form.validateFields(),
        form.validateFields(),
      ])
      if (qualityDataList.length > 10) {
        message.warning('资质图片最多上传10张')
        return
      }
      if (type === 'submit' && !checkRequiredQualityTypes()) {
        return
      }
      message.loading('保存中', 0)
      // @ts-ignore
      const data = extendedInfoList.map((child) => {
        const fieldValue = value[`${projectCode}_${child.fieldKey}`]
        const fieldValueName = value[`${projectCode}_${child.fieldKey}_name`]

        const fieldValueData =
          child.controlType === '5'
            ? (fieldValue as string[])?.join(',')
            : fieldValue
        return {
          ...child,
          fieldValue:
            child.relateField && fieldValueData === undefined
              ? 'null'
              : fieldValueData,
          fieldValueName:
            child.relateField &&
            (fieldValueName === undefined || fieldValueData === 'null')
              ? 'null'
              : fieldValueName || fieldValueData,
        }
      })
      const params = {
        id: routerParams.id,
        extendedInfoList: data,
        attributesJson: {},
        materialAptitudeFileList: qualityDataList,
        // 资料附件（12 类 docType 资质）
        qualDocFileList,
        saleJobNumber: formValue.saleJobNumber,
        saleName: formValue.saleName,
        saleRemark: formValue.saleRemark,
      }
      if (type === 'save') {
        const resData = await POST_SAVE_MATERIAL_REPORT(params)
        if (resData.code === 0) {
          message.success('已成功')
          reportProjectCategoryAdoptions()
          // 关闭页面，回退路由
          onClickClose()
        } else {
          message.destroy()
        }
      } else {
        preCheckSubmitForSave(params)
      }
    } catch (errorInfo) {
      const error = (errorInfo as any).errorFields[0].errors[0]
      message.warning(error)
      const errorname = (errorInfo as any).errorFields[0].name
      // 返回报错信息，滚动到第一个报错的位置
      form.scrollToField(errorname.toString(), { behavior: 'smooth' })
    }
  }
  const onCommitSaveMaterialReport = async (params: any) => {
    const resData = await POST_SUMBIT_MATERIAL_REPORT(params)
    if (resData.code === 0) {
      message.success('已成功')
      reportProjectCategoryAdoptions()
      // 关闭页面，回退路由
      onClickClose()
    } else {
      message.destroy()
    }
  }

  const setQualityDataList = (data: QualityList[]) => {
    dispatch(setQualityDataListAction(data))
  }

  // 改变资料附件
  const onChangeAptitude = (list: AptitudeFile[]) => {
    dispatch(setQualDocFileListAction(list))
  }
  // 点击保存
  async function onSaveAndSumbit() {
    try {
      // 格式化表单数据
      const [value, formValue] = await Promise.all([
        platform_form.validateFields(),
        form.validateFields(),
      ])
      if (qualityDataList.length > 10) {
        message.warning('资质图片最多上传10张')
        return
      }
      if (!checkRequiredQualityTypes()) {
        return
      }
      message.loading('保存中', 0)
      // @ts-ignore
      const data = extendedInfoList.map((child) => {
        const fieldValue = value[`${projectCode}_${child.fieldKey}`]
        const fieldValueName = value[`${projectCode}_${child.fieldKey}_name`]

        const fieldValueData =
          child.controlType === '5'
            ? (fieldValue as string[])?.join(',')
            : fieldValue

        return {
          ...child,
          fieldValue:
            child.relateField && fieldValueData === undefined
              ? 'null'
              : fieldValueData,
          fieldValueName:
            child.relateField &&
            (fieldValueName === undefined || fieldValueData === 'null')
              ? 'null'
              : fieldValueName || fieldValueData,
        }
      })
      const formData = form.getFieldsValue()
      const reportFieldValues = buildReportFieldValues(
        reportFieldConfigList,
        value,
      )
      const params = {
        projectCode: routerParams.platformCode, // 项目code
        projectName: formData.projectName, // 项目名称
        reportType: routerParams.submissionType, // 提报类型
        extendedInfoList: data, // 扩展信息JSON
        //资质图片类文件
        materialAptitudeFileList: qualityDataList,
        // 资料附件（12 类 docType 资质）
        qualDocFileList,
        materialCode: formData.materialCode, // 物料编码（商品编码）
        materialId: formData.materialId, // 物料ID
        materialName: formData.materialName, // 物料名称
        supplierId: getSupplierId(), // 供应商ID
        supplierName: GetLocalStorage('HOME_DATA')?.enterpriseName, // 供应商名称
        attributesJson: {},
        saleJobNumber: formValue.saleJobNumber,
        saleName: formValue.saleName,
        saleRemark: formValue.saleRemark,
        reportFieldValues,
      }
      preCheckSubmit(params)
    } catch (errorInfo) {
      const error = (errorInfo as any).errorFields[0].errors[0]
      message.warning(error)
      const errorname = (errorInfo as any).errorFields[0].name
      // 返回报错信息，滚动到第一个报错的位置
      form.scrollToField(errorname.toString(), { behavior: 'smooth' })
    }
  }

  const onCommitMaterialReport = async (params: any) => {
    const resData = await POST_SUBMIT_MATERIAL_REPORT_NEW(params)
    if (resData.code === 0) {
      message.success('已成功')
      reportProjectCategoryAdoptions()
      // 关闭页面，回退路由
      onClickClose()
    } else {
      message.destroy()
    }
  }

  // 暂存
  const onStorage = async () => {
    const formData = form.getFieldsValue()
    const platform_formData = serializeFormValuesForStorage(
      platform_form.getFieldsValue(),
    )

    const data = {
      formData,
      platform_formData,
      state,
    }

    const params = {
      projectCode: routerParams.platformCode,
      materialCode: routerParams.productCode,
      storageInfoJson: JSON.stringify(data),
    }

    const res = await POST_STORAGE_NEW_MATERIAL(params)

    if (res.code === 0) {
      message.success('已暂存')
      reportProjectCategoryAdoptions()
    } else {
      message.error(res.msg)
    }
  }

  // 解析动态字段下拉选项：优先 fieldEnumValueList，兜底 controlRuleJson.options
  const parseReportFieldOptions = (field: ReportFieldConfigVO) => {
    if (field.fieldEnumValueList?.length) return field.fieldEnumValueList
    try {
      const rule = field.controlRuleJson
        ? JSON.parse(field.controlRuleJson)
        : null
      if (Array.isArray(rule?.options)) return rule.options
    } catch (error) {
      return []
    }
    return []
  }

  // 根据 ProjectValidationInfo 的配置 + 表单值组装 submitNew 所需 reportFieldValues
  const buildReportFieldValues = (
    configList: ReportFieldConfigVO[],
    platformFormValue: Record<string, any>,
  ) =>
    configList
      ?.map((field) => {
        if (!field.fieldKey) return null
        const fieldName = `reportField_${field.fieldKey}`
        const raw = platformFormValue[fieldName]
        if (
          raw === undefined ||
          raw === null ||
          raw === '' ||
          (Array.isArray(raw) && raw.length === 0)
        ) {
          return null
        }

        let fieldValue = ''
        let fieldValueLabel = ''
        if (field.controlType === '6' && Array.isArray(raw)) {
          fieldValue = raw.join(',')
          const options = parseReportFieldOptions(field)
          fieldValueLabel = raw
            .map(
              (item) =>
                options.find(
                  (opt: { label: string; value: string }) => opt.value === item,
                )?.label || item,
            )
            .join(',')
        } else if (field.controlType === '5') {
          fieldValue = String(raw)
          const options = parseReportFieldOptions(field)
          fieldValueLabel =
            options.find(
              (opt: { label: string; value: string }) => opt.value === raw,
            )?.label || fieldValue
        } else if (field.controlType === '4' && moment.isMoment(raw)) {
          let rule: Record<string, any> = {}
          try {
            rule = field.controlRuleJson
              ? JSON.parse(field.controlRuleJson)
              : {}
          } catch {
            /* controlRuleJson 非法，使用默认格式 */
          }
          const format = rule?.format || 'YYYY-MM-DD'
          fieldValue = raw.format(format)
          fieldValueLabel = fieldValue
        } else {
          fieldValue = String(raw)
          fieldValueLabel = fieldValue
        }

        return {
          configId: field.id,
          fieldKey: field.fieldKey,
          fieldValue,
          fieldValueLabel,
        }
      })
      .filter(Boolean)

  // 设置预审错误信息
  const setPreCheckErrors = (errors: PreCheckErrors) => {
    dispatch(setPreCheckErrorsAction(errors))
  }

  // 同步 submitType state 到 ref
  useEffect(() => {
    submitTypeRef.current = submitType
  }, [submitType])

  // 设置提交类型
  const setSubmitType = (type: 'new' | 'old') => {
    submitTypeRef.current = type // 立即更新 ref，确保后续调用能获取到最新值
    dispatch(setSubmitTypeAction(type))
  }

  // 提交数据（预审成功后调用 - 根据类型选择不同的提交方式）
  const handleSubmit = async (params: any) => {
    // 使用 ref 获取最新的 submitType 值，避免闭包问题
    const currentSubmitType = submitTypeRef.current
    if (currentSubmitType === 'new') {
      await onCommitMaterialReport(params)
    } else {
      await onCommitSaveMaterialReport(params)
    }
  }

  // 使用预审 Hook（统一处理新接口和旧接口）
  const { executePreCheck, PreCheckModalComponent, submitting } = usePreCheck({
    form,
    onSubmit: handleSubmit,
    onModify: (errors) => {
      setPreCheckErrors(errors)
    },
  })

  // 提交数据（带预审 - 新接口）
  const preCheckSubmit = async (params: any) => {
    setPreCheckErrors({})
    setSubmitType('new')
    await executePreCheck(
      params,
      preReviewOfMaterialsTypeEnum.getValueByLabel('提报驳回更新') || '',
    )
  }

  // 提交数据（带预审 - 旧接口，用于 onSave('submit')）
  const preCheckSubmitForSave = async (params: any) => {
    setPreCheckErrors({})
    setSubmitType('old')
    await executePreCheck(
      params,
      preReviewOfMaterialsTypeEnum.getValueByLabel('单条提报') || '',
    )
  }
  return {
    usehookstate: state,
    form,
    platform_form,
    brandIsSale,
    changeList,
    dispatchhook: dispatch,
    setChangeList,
    onFieldsChange,
    onChangePic,
    onChangeFile,
    onChangeDetectionfile,
    onChangeQualityfile,
    onChangeDetailPic,
    onChangeFieldlist,
    onChangeUploadPicCode,
    onChangeCate,
    onChangeBrandSale,
    setFieldList,
    getFieldList,
    onClickClose,
    onClickRecord,
    onCancelrecord,
    onExpansion,
    onChangeLoading,
    formatFormFields,
    getformatFormFields,
    reloaddata,
    code,
    tempCode,
    setTempCodeFun,
    onChangeDelivery,
    changeUnitDisabled,
    getTempCode,
    setMaterialType,
    changeItemList,
    handleOpenExtractModal,
    closeExtractModal,
    clickCopy,
    externalLinkList,
    setExternalLinkList,
    onSave,
    onStorage,
    onSaveAndSumbit,
    setQualityDataList,
    qualDocFileList,
    onChangeAptitude,
    frontendHintText,
    preCheckErrors,
    submitType,
    onCommitMaterialReport,
    onCommitSaveMaterialReport,
    setPreCheckErrors,
    setSubmitType,
    setReportFieldConfigList,
    PreCheckModalComponent,
    relateFieldKeySet,
    handleRelateFieldBlur,
    relateFieldCalcLoading,
    submitting,
  }
}

export default useHook

// 表单各数值类型
export interface FormFields {
  owner?: string // 货主
  ownerName?: string // 货主名称
  tempCode?: string // 临时编码
  name?: string // 商品名称
  childId?: string // 物料id 标识所有用到form的地方此次操作为新增或者编辑或者审核等
  // material_state?: string; //物料状态
  dataNature?: string // 物料性质
  // 业务组织
  create_code?: string // 创建组织编码
  consignor?: string // 货主
  consignorName?: string // 货主名称
  // create_user?: string; //创建人
  use_organ?: string[] // 使用组织
  // 身份属性
  code?: string // 商品编码
  barCode?: string // 条形码
  remakers?: string // 描述
  // name?: string; //商品名称
  mncode?: string // 助记码
  spec?: string // 型号规格
  // 辅助属性
  catoyName?: string // 所属类目
  catoyid?: string // 所属类目id
  invencategory?: string // 存货类别
  invencategoryName?: string // 存货类别名称
  inremakers?: string // 内部备注
  materialbrand?: string // 物料品牌
  materialbrandName?: string // 物料品牌名称
  materialbrandCode?: string // 物料品牌code
  materialbrandSale?: string // 品牌是否可售

  baseunit?: string // 基本单位
  baseunitName?: string // 基本单位名称
  deliveryday?: string // 发货日(天)
  // 财务考核属性
  procurement?: string // 采购员
  procurementName?: string // 采购员名称
  procurementDept?: string // 采购部门
  procurementDeptName?: string // 采购部门名称
  examinationType?: string // 考核类别
  examinationTypeName?: string // 考核类别名称
  examinationPerson?: string // 考核员
  examinationPersonName?: string // 考核员名称

  // 价格属性
  marketprice?: string // 市场价
  mallprice?: string // 商城价
  transferprice?: string // 调拨价
  // 控制属性
  onshelf?: '1' | '0' // 商城上架
  mallsales?: '1' | '0' // 商城可售不可售
  allowprocurement?: '1' | '0' // 允许采购
  inventory?: '1' | '0' // 允许库存
  outcommit?: '1' | '0' // 允许委外
  sales?: '1' | '0' // 允许销售
  product?: '1' | '0' // 允许生产
  assets?: '1' | '0' // 允许资产
  isFreeShipping?: '1' | '0' // 是否包邮
  isOverLength?: '1' | '0' // 是否超长
  // 重量属性
  grossweight?: string // 毛重(千克)
  netweight?: string // 净重(千克)
  // 尺寸属性
  size1?: string // 长
  size2?: string // 宽
  size3?: string // 高
  volume?: string // 体积
  // 库存属性

  materialattr?: string // 物料属性
  materialattrName?: string // 物料属性 名称
  taxtype?: string // 税分类
  taxtypeName?: string // 税分类 名称
  defaulttax?: string // 默认税率
  defaulttaxName?: string // 默认税率 名称
  salesunit?: string // 销售单位
  salesunitName?: string // 销售单位 名称
  salesvaluaunit?: string // 销售计价单位
  salesvaluaunitName?: string // 销售计价单位 名称
  procureunit?: string // 采购单位
  procureunitName?: string // 采购单位 名称
  procurevaluaunit?: string // 采购计价单位
  procurevaluaunitName?: string // 采购计价单位 名称
  inventoryunit?: string // 库存单位
  inventoryunitName?: string // 库存单位 名称
  costunit?: string // 成本单位
  costunitName?: string // 成本单位 名称
  rulestype?: string // 批号编码规则
  rulestypeName?: string // 批号编码规则 名称
  canBeMainProduct?: '1' | '0' // 可为主产品
  batchmanage?: '1' | '0' // 启用批号管理
  currency?: string // 币别
  onlocklib?: '1' | '0' // 允许锁库
  // 销售属性
  onreturn?: '1' | '0' // 允许退货
  // 采购属性
  onreturnmaterial?: '1' | '0' // 允许退料
  // 物料维度
  pricestate?: '1' | '0' // 影响价格
  coststate?: '1' | '0' // 影响成本
  exemptPostage?: '1' | '0' // 包邮
  overlength?: '1' | '0' // 超长
  // 拓展属性
  level?: string // 物料等级
  // 主图
  picMatch?: string // 图片匹配度
  // 原始图是否可用
  orgpic?: string // 是否可用
  freight?: string // 调拨价是否包含运费
  productManager?: string // 产品经理
  productManagerId?: string // 产品经理id
  [x: string]: any
}
/*
 * @Descripttion:
 * @Author: 黄佳鑫
 * @Date: 2025-07-11 16:18:03
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2026-01-14 13:23:21
 */
import { useReducer, useEffect, useState, useRef } from 'react'
import moment from 'moment'
import { imgFile } from '../../modules/goodsdetailmodules/uploadimg'
import { fileFile } from '../../modules/goodsdetailmodules/uploadfiles'
import { Form, message } from 'antd'
import {
  GetLocalStorage,
  MaterialType,
  getFeeText,
  getSupplierId,
  isResponseCodeSuccess,
  formatterPrice,
} from '../../tools/util'
import {
  GET_ERP_PRODUCTCHILD_ADD_REQUIRED,
  // GET_GH03_CATEGORY,
  GET_MARKUP_TEMPCODE,
} from '../../api/MaterialApi'
import {
  ExtendedInfo,
  POST_SAVE_MATERIAL_REPORT,
  POST_SUMBIT_MATERIAL_REPORT,
  QualityList,
  POST_SUBMIT_MATERIAL_REPORT_NEW,
  POST_STORAGE_NEW_MATERIAL,
  ReportFieldConfigVO,
} from '../../api/reportApi'
import { history, useTypedSelector } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { delTabsAction } from '../../modules/authtoken'
import { delRouterAction } from '../../modules/routerModules'
import {
  PlatformField,
  // setLocalCategoryInfoAction,
} from '../../modules/goodsdetailmodules/reducer'
import {
  setModuleDataAction,
  delModuleDataAction,
} from '../../modules/pagecache'
import { userRouter } from '../../route'
import {
  ExternalLinkType,
  toExternalLinkPayload,
} from '@/modules/goodsdetailmodules/externallink'
import { AptitudeFile } from '@/modules/goodsdetailmodules/AptitudeAttach/typing'
import { pick } from 'lodash'
import { useRelateFieldCalc } from '@/hooks/useRelateFieldCalc'
import { reportProjectCategoryAdoptions } from '@/tools/projectCategoryAdopt'
import { PreCheckErrors, usePreCheck } from '@/hooks/usePreCheck'
import {
  preReviewOfMaterialsTypeEnum,
  reportTypeEnum,
} from '@/global/enum/product'
import { getMissingQualityTypeLabels } from '@/modules/goodsdetailmodules/util'

const ACTION_TYPE = {
  CHANGE_PIC: 'change_pic_AT', // 改变预览图
  CHANGE_FILE: 'change_file_AT', // 改变附件
  CHANGE_DETECTION_FILE: 'change_detection_file_AT', // 改变检测报告
  CHANGE_QUALITY_FILE: 'CHANGE_QUALITY_FILE', // 改变质量证明
  CHANGE_DETAIL_PIC: 'change_text_AT', // 改变文本数据
  CHANGE_FIELDLIST: 'change_fieldList', // 改变拓展属性
  CHANGE_PREFIXCODE: 'change_productCode', // 上传图片前缀编码
  SET_CURRENT_PARAM: 'set_current_param', // 设置当前页面参数
  CHANGE_EXPPANSION: 'change_expansion', // 切换默认信息展开隐藏
  CHANGE_RECORD: 'change_record', // 切换操作记录信息展开隐藏
  CHANGE_LOADING: 'change_loading', // loading
  CHANGE_DATA: 'CHANGE_DATA', // 替换所有状态
  SET_BRAND_SALE: 'SET_BRAND_SALE', // 根据品牌是否可售设置商城是否可以修改
  SET_ERP_CODE: 'SET_ERP_CODE',
  CHANGE_DELIVERY: 'CHANGE_DELIVERY', // 改变发货日,
  SET_UNIT_DISABLED: 'SET_UNIT_DISABLED', // 基本单位是否禁用
  SET_MATERIAL_TYPE: 'SET_MATERIAL_TYPE', // 物料类型
  SET_ITEM_LIST: 'SET_ITEM_LIST', // 项目字段
  SET_EXTRACT_VISIBLE: 'SET_EXTRACT_VISIBLE', // 快捷提取外链弹框
  SET_GO_SHIBEI_type: 'SET_GO_SHIBEI_type', // 拾贝弹框类型
  SET_ROUTER_PARAMS: 'SET_ROUTER_PARAMS', // 设置路由参数
  SET_EXTENDED_INFO_LIST: 'SET_EXTENDED_INFO_LIST', // 设置拓展属性列表
  SET_PROJECT_CODE: 'SET_PROJECT_CODE', // 设置项目编码
  SET_QUALITY_DATA_LIST: 'SET_QUALITY_DATA_LIST', // 设置资质图片列表
  SET_QUAL_DOC_FILE_LIST: 'SET_QUAL_DOC_FILE_LIST', // 设置资料附件列表
  SET_FRONTEND_HINT_TEXT: 'SET_FRONTEND_HINT_TEXT', // 设置四级类目前台提示文案
  SET_PRE_CHECK_ERRORS: 'SET_PRE_CHECK_ERRORS', // 设置预审错误信息
  SET_SUBMIT_TYPE: 'SET_SUBMIT_TYPE', // 设置提交类型
}
export interface State {
  pictures: imgFile[]
  productFileList: fileFile[]
  detectionFileList: fileFile[]
  qualityList: fileFile[]
  detailPic: imgFile[]
  fieldList: any[]
  productCode: string // 三级类目前缀编码
  isExpansion: boolean
  isRecord: boolean // 操作记录
  loadingPage: boolean
  brandIsSale: boolean
  code: string
  tempCode: string
  hasDelivery: boolean
  unitDisabled: boolean
  materialType?: MaterialType
  itemsList: PlatformField[]
  extractVisible: boolean // 快捷拾取弹框
  shibeiType: string // 拾取类型
  routerParams: any // 路由参数
  extendedInfoList: ExtendedInfo[]
  projectCode: string
  qualityDataList: QualityList[]
  qualDocFileList: AptitudeFile[] // 资料附件
  frontendHintText: string // 四级类目前台提示文案（选择类目时带出）
  preCheckErrors: PreCheckErrors
  submitType: 'new' | 'old'
}

const defaultHookState: State = {
  pictures: [], // 预览图
  productFileList: [], // 附件
  detectionFileList: [], // 检测报告
  qualityList: [], // 质量证明
  detailPic: [],
  productCode: '',
  fieldList: [],
  // currentparam: {},
  isExpansion: false, // true 展开 false 隐藏
  isRecord: false, // 操作记录
  loadingPage: false,
  brandIsSale: false,
  code: GetLocalStorage('SUPPLIER_CODE'),
  tempCode: '',
  hasDelivery: true,
  unitDisabled: true,
  itemsList: [],
  extractVisible: false,
  shibeiType: 'extract',
  materialType: '1',
  routerParams: {},
  extendedInfoList: [],
  projectCode: '',
  qualityDataList: [],
  qualDocFileList: [],
  frontendHintText: '',
  preCheckErrors: {},
  submitType: 'new',
}
const reducer = (state: State, action: { type: string; value?: any }) => {
  let arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.CHANGE_PIC:
      arr.pictures = action.value
      return arr
    case ACTION_TYPE.CHANGE_FILE:
      arr.productFileList = action.value
      return arr
    case ACTION_TYPE.CHANGE_DETECTION_FILE:
      arr.detectionFileList = action.value
      return arr
    case ACTION_TYPE.CHANGE_QUALITY_FILE:
      arr.qualityList = action.value
      return arr
    case ACTION_TYPE.CHANGE_DETAIL_PIC:
      arr.detailPic = action.value
      return arr
    case ACTION_TYPE.CHANGE_FIELDLIST:
      arr.fieldList = action.value
      return arr
    case ACTION_TYPE.CHANGE_PREFIXCODE:
      arr.productCode = action.value
      return arr
    case ACTION_TYPE.CHANGE_EXPPANSION:
      arr.isExpansion = action.value
      return arr
    case ACTION_TYPE.CHANGE_RECORD:
      arr.isRecord = action.value
      return arr
    case ACTION_TYPE.CHANGE_LOADING:
      arr.loadingPage = action.value
      return arr
    case ACTION_TYPE.CHANGE_DATA:
      arr = action.value
      return arr
    case ACTION_TYPE.SET_BRAND_SALE:
      arr.brandIsSale = action.value
      return arr
    case ACTION_TYPE.SET_ERP_CODE:
      arr.tempCode = action.value
      return arr
    case ACTION_TYPE.CHANGE_DELIVERY:
      arr.hasDelivery = action.value
      return arr
    case ACTION_TYPE.SET_UNIT_DISABLED:
      arr.unitDisabled = action.value
      return arr
    case ACTION_TYPE.SET_MATERIAL_TYPE:
      arr.materialType = action.value
      return arr
    case ACTION_TYPE.SET_ITEM_LIST:
      arr.itemsList = action.value
      return arr
    case ACTION_TYPE.SET_EXTRACT_VISIBLE:
      arr.extractVisible = action.value
      return arr
    case ACTION_TYPE.SET_GO_SHIBEI_type:
      arr.shibeiType = action.value
      return arr
    case ACTION_TYPE.SET_ROUTER_PARAMS:
      arr.routerParams = action.value
      return arr
    case ACTION_TYPE.SET_EXTENDED_INFO_LIST:
      arr.extendedInfoList = action.value
      return arr
    case ACTION_TYPE.SET_PROJECT_CODE:
      arr.projectCode = action.value
      return arr
    case ACTION_TYPE.SET_QUALITY_DATA_LIST:
      arr.qualityDataList = action.value
      return arr
    case ACTION_TYPE.SET_QUAL_DOC_FILE_LIST:
      arr.qualDocFileList = action.value
      return arr
    case ACTION_TYPE.SET_FRONTEND_HINT_TEXT:
      arr.frontendHintText = action.value
      return arr
    case ACTION_TYPE.SET_PRE_CHECK_ERRORS:
      arr.preCheckErrors = action.value
      return arr
    case ACTION_TYPE.SET_SUBMIT_TYPE:
      arr.submitType = action.value
      return arr
    default:
      return state
  }
}

const changepicAction = (params: imgFile[]) => ({
  type: ACTION_TYPE.CHANGE_PIC,
  value: params,
})
const changefileAction = (params: fileFile[]) => ({
  type: ACTION_TYPE.CHANGE_FILE,
  value: params,
})
const changeDetectionfileAction = (params: fileFile[]) => ({
  type: ACTION_TYPE.CHANGE_DETECTION_FILE,
  value: params,
})
const changeQualityfileAction = (params: fileFile[]) => ({
  type: ACTION_TYPE.CHANGE_QUALITY_FILE,
  value: params,
})
const changeDetailPicAction = (params: imgFile[]) => ({
  type: ACTION_TYPE.CHANGE_DETAIL_PIC,
  value: params,
})
const changeFieldlistAction = (params: any[]) => ({
  type: ACTION_TYPE.CHANGE_FIELDLIST,
  value: params,
})
const changePrefixcodeAction = (params: string) => ({
  type: ACTION_TYPE.CHANGE_PREFIXCODE,
  value: params,
})

// 设置展开隐藏
const setExpansionAction = (params: boolean) => ({
  type: ACTION_TYPE.CHANGE_EXPPANSION,
  value: params,
})

// 设置操作记录信息显示隐藏
const changeIsrecordAction = (params: boolean) => ({
  type: ACTION_TYPE.CHANGE_RECORD,
  value: params,
})
// loading
const changeLoadingAction = (params: boolean) => ({
  type: ACTION_TYPE.CHANGE_LOADING,
  value: params,
})

// 重置所有状态
const changeDataAction = (params: State) => ({
  type: ACTION_TYPE.CHANGE_DATA,
  value: params,
})

// 设置商城是否可售能否修改
const changeMallSaleAction = (params: boolean) => ({
  type: ACTION_TYPE.SET_BRAND_SALE,
  value: params,
})

// ERPCODE
const setErpCode = (params: string) => ({
  type: ACTION_TYPE.SET_ERP_CODE,
  value: params,
})

// 改变发货期配置
const changeDeliveryAction = (params: boolean) => ({
  type: ACTION_TYPE.CHANGE_DELIVERY,
  value: params,
})

// 基本单位是否禁用
const setUnitDisabledAction = (params: boolean) => ({
  type: ACTION_TYPE.SET_UNIT_DISABLED,
  value: params,
})

// 物料类型
const setMaterialTypeAction = (params: MaterialType) => ({
  type: ACTION_TYPE.SET_MATERIAL_TYPE,
  value: params,
})

// 项目字段
const setItemListAction = (params: PlatformField[]) => ({
  type: ACTION_TYPE.SET_ITEM_LIST,
  value: params,
})

// 快捷提取外链弹框
const setExtractVisible = (params: boolean) => ({
  type: ACTION_TYPE.SET_EXTRACT_VISIBLE,
  value: params,
})

// 拾贝弹框类型
const setGoShibeiType = (params: string) => ({
  type: ACTION_TYPE.SET_GO_SHIBEI_type,
  value: params,
})

// 设置路由参数
export const setRouterParams = (params: any) => ({
  type: ACTION_TYPE.SET_ROUTER_PARAMS,
  value: params,
})

export const setProjectCodeAction = (params: string) => ({
  type: ACTION_TYPE.SET_PROJECT_CODE,
  value: params,
})
export const setExtendedInfoListAction = (params: ExtendedInfo[]) => ({
  type: ACTION_TYPE.SET_EXTENDED_INFO_LIST,
  value: params,
})

export const setQualityDataListAction = (params: QualityList[]) => ({
  type: ACTION_TYPE.SET_QUALITY_DATA_LIST,
  value: params,
})

// 设置资料附件列表
export const setQualDocFileListAction = (params: AptitudeFile[]) => ({
  type: ACTION_TYPE.SET_QUAL_DOC_FILE_LIST,
  value: params,
})

export const setFrontendHintTextAction = (params: string) => ({
  type: ACTION_TYPE.SET_FRONTEND_HINT_TEXT,
  value: params,
})

export const setPreCheckErrorsAction = (params: PreCheckErrors) => ({
  type: ACTION_TYPE.SET_PRE_CHECK_ERRORS,
  value: params,
})
export const setSubmitTypeAction = (params: 'new' | 'old') => ({
  type: ACTION_TYPE.SET_SUBMIT_TYPE,
  value: params,
})

const useHook = () => {
  const [state, dispatch] = useReducer(reducer, defaultHookState)
  const dispatchRedux = useDispatch()
  const {
    pictures,
    productFileList,
    detectionFileList,
    qualityList,
    fieldList,
    isExpansion,
    detailPic,
    brandIsSale,
    code,
    tempCode,
    hasDelivery,
    itemsList,
    // materialType,
    routerParams,
    extendedInfoList,
    projectCode,
    qualityDataList,
    qualDocFileList,
    frontendHintText,
    preCheckErrors,
    submitType,
  } = state
  const { tabsData } = useTypedSelector((state) => state.authtoken)
  const location = useLocation()
  const { pathname } = location
  const [form] = Form.useForm()
  const [platform_form] = Form.useForm()
  const [changeList, setChangeList] = useState<boolean>(false)
  // 使用 ref 存储最新的 submitType，确保 handleSubmit 能获取到最新值
  const submitTypeRef = useRef<'new' | 'old'>(submitType)
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const dispatchPageCache = useDispatch()
  const [externalLinkList, setExternalLinkList] = useState<ExternalLinkType[]>(
    [],
  )
  const [reportFieldConfigList, setReportFieldConfigList] = useState<
    ReportFieldConfigVO[]
  >([])

  // 缓存数据
  const onCache = () => {
    // 缓存存数据
    const pathName = history.location.pathname
    const formData = form.getFieldsValue()
    const platformsInfo = platform_form?.getFieldsValue() || {}
    const action = setModuleDataAction({
      key: pathName,
      data: {
        pageState: state, // 当前状态
        formData: formData,
        platformsInfo,
        externalLinkData: externalLinkList,
      },
    })
    dispatchRedux(action)
  }

  // ── 关联字段计算逻辑（共享 hook） ──
  const { relateFieldKeySet, handleRelateFieldBlur, relateFieldCalcLoading } =
    useRelateFieldCalc({
      reportFieldConfigList,
      platform_form,
      projectCode,
      onAfterCalc: onCache,
    })

  // 将表单值序列化为可 JSON 存储的数据（DatePicker 的 moment 需要特殊处理）
  const serializeFormValuesForStorage = (values: Record<string, any>) => {
    const result: Record<string, any> = {}
    Object.keys(values || {}).forEach((key) => {
      const value = values[key]
      if (moment.isMoment(value)) {
        result[key] = {
          __type: 'moment',
          value: value.toISOString(),
        }
      } else if (Array.isArray(value)) {
        result[key] = value.map((item) =>
          moment.isMoment(item)
            ? { __type: 'moment', value: item.toISOString() }
            : item,
        )
      } else {
        result[key] = value
      }
    })
    return result
  }

  useEffect(() => {
    const flag = getpagecache()
    const { state } = location as any
    console.log(state, 'state')
    if (flag && !state) {
      form.setFieldsValue(flag.formData)
      platform_form.setFieldsValue(flag.platformsInfo)
      dispatch(changeDataAction(flag.pageState))
      setExternalLinkList(flag.externalLinkData)
      setChangeList(!changeList)
    } else if ((location.state as any)?.type === 'copy') {
      dispatch(setRouterParams(location.state))
      const { platformsInfo, formData, pageState, type, externalLinkData } =
        location.state as any
      if (type === 'copy') {
        setExternalLinkList(externalLinkData)
        form.setFieldsValue(formData)
        platform_form.setFieldsValue(platformsInfo)
        dispatch(changeDataAction(pageState))
        changeUnitDisabled(false)
        getTempCode()
        setChangeList(!changeList)
      }
    } else if (pathname === '/srm/addgoods') {
      changeUnitDisabled(false)
    }

    // 这屎山和结构真无敌了
    if (
      state?.BtnState?.includes('Edit') &&
      !state?.productMdmId &&
      pathname !== '/srm/editgoods'
    ) {
      changeUnitDisabled(false)
    }
    // getGH03Category()
  }, [])

  // 改变图片
  const onChangePic = (pic: imgFile[]) => {
    dispatch(changepicAction(pic))
  }

  // 改变产品资料
  const onChangeFile = (file: fileFile[]) => {
    dispatch(changefileAction(file))
  }

  // 改变检测报告
  const onChangeDetectionfile = (file: fileFile[]) => {
    dispatch(changeDetectionfileAction(file))
  }

  // 改变质量证明
  const onChangeQualityfile = (file: fileFile[]) => {
    dispatch(changeQualityfileAction(file))
  }

  // 改变详情图
  const onChangeDetailPic = (pic: imgFile[]) => {
    dispatch(changeDetailPicAction(pic))
  }

  // 改变拓展属性
  const onChangeFieldlist = (
    param: {
      id: string
      name: string
      types: string[]
      platformCodeAttribute: string[]
      platformCodeLabel: string[]
      platformAbbreviationName: string
    }[],
  ) => {
    dispatch(changeFieldlistAction(param))
  }

  // 上传图片编码
  const onChangeUploadPicCode = (param: string) => {
    dispatch(changePrefixcodeAction(param))
  }

  // 点击操作记录
  const onClickRecord = () => {
    const action = changeIsrecordAction(true)
    dispatch(action)
  }

  // 关闭操作记录
  const onCancelrecord = () => {
    const action = changeIsrecordAction(false)
    dispatch(action)
  }
  // 展开收起
  const onExpansion = () => {
    const action = setExpansionAction(!isExpansion)
    dispatch(action)
  }

  // 切换类目 设置扩展属性 前缀编码
  const onChangeCate = async (
    e: string,
    type?: string,
    _materialCode?: string,
    frontendHintText?: string,
  ) => {
    const id = e
    const resData: any = await GET_ERP_PRODUCTCHILD_ADD_REQUIRED({
      categoryId: id,
      productType: type ?? form.getFieldValue('productType'),
    })
    if (resData.code === 0) {
      onChangeFieldlist(resData.data)
    }
    // 四级类目前台提示文案（选择类目/详情回填时带出）
    dispatch(setFrontendHintTextAction(frontendHintText ?? ''))
  }

  // 设置拓展属性值
  const setFieldList = (fieldNameList: any[]) => {
    const list = fieldNameList.map((item) => ({
      ...item,
      types: item.type,
    }))
    onChangeFieldlist(list)
    // 拓展属性 表单赋值
    fieldNameList.map((item: any) => {
      form.setFieldsValue({
        [item.id]: item.valueType === '1' ? item.enumValueList : item.value,
      })
      return item
    })
  }

  // 获取拓展属性值
  const getFieldList = () => {
    const arr: any[] = []
    fieldList.map((item: any) => {
      const value = form.getFieldValue(item.id)
      arr.push({
        ...item,
        id: item.id,
        valueType: item.valueType || '2',
        enumValueList: item.valueType === '1' ? value || '' : '',
        value: item.valueType !== '1' ? value || '' : '',
        required: item.required,
        multiple: item.multiple || '0',
      })
      return item
    })
    return arr
  }

  // 表单变化
  const onFieldsChange = () => {
    onCache()
  }

  useEffect(() => {
    // 缓存存数据
    onCache()
    // eslint-disable-next-line
  }, [state, externalLinkList])

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 关闭
  const onClickClose = (path?: any) => {
    let newurl = ''
    if (tabsData.length === 0) {
      // 最后一个tabs
      newurl = '/srm/home'
    }
    let delkey = ''
    if (tabsData.length > 0) {
      let param = 0
      tabsData.map((item, index) => {
        if (item.url === pathname) {
          delkey = item.key
          param = index - 1
        }
        return item
      })
      // 排除下标为1的
      const url = param >= 0 ? tabsData[param].url : '/srm/home'
      newurl = url
    }
    // 删除标签 删除对应路由 删除缓存数据 跳转前一个标签页
    dispatchRedux(delTabsAction(delkey))
    dispatchRedux(delRouterAction(delkey))
    dispatchPageCache(delModuleDataAction(pathname))
    if (path) {
      dispatchPageCache(delModuleDataAction(path))
    }
    history.replace(newurl)
  }

  // 控制 loading
  const onChangeLoading = (param: boolean) => {
    const action = changeLoadingAction(param)
    dispatch(action)
  }

  // 重置所有状态
  const reloaddata = (param: State) => {
    const action = changeDataAction(param)
    dispatch(action)
  }

  // 物料详情 表单数据（回填）
  const formatFormFields = (formdata: any) => {
    setMaterialType(formdata.srmProductType)
    onChangeDelivery(
      !formdata.deliveryDay || formdata.deliveryDay === '详询客服'
        ? true
        : false,
    )
    // 主图
    onChangePic(
      formdata.mainUrl?.map((item: any) => {
        const targetIndex =
          item.fullUrl.indexOf(
            '/',
            item.fullUrl.indexOf('/', item.fullUrl.indexOf('/') + 1) + 1,
          ) + 1
        return {
          url: item.fullUrl.substring(targetIndex),
          name: '',
          baseUrl: item.fullUrl.substring(0, targetIndex),
        }
      }),
    )
    // 详情图
    onChangeDetailPic(
      formdata.detailPicList?.map((item: string) => {
        const targetIndex =
          item.indexOf('/', item.indexOf('/', item.indexOf('/') + 1) + 1) + 1
        return {
          url: item.substring(targetIndex),
          name: '',
          baseUrl: item.substring(0, targetIndex),
        }
      }),
    )
    // 产品资料
    onChangeFile(
      formdata.fileList?.map((item: any) => ({
        url: item.fileUrl,
        name: item.fileName,
        baseUrl: item.baseUrl || GetLocalStorage('BASEURL'),
      })),
    )
    // 检测报告
    onChangeDetectionfile(
      formdata.testReportFileList?.map((item: any) => ({
        url: item.fileUrl,
        name: item.fileName,
        baseUrl: item.baseUrl || GetLocalStorage('BASEURL'),
      })),
    )
    // 质量证明
    onChangeQualityfile(
      formdata.certificateOfQuality?.map((item: any) => ({
        url: item.fileUrl,
        name: item.fileName,
        baseUrl: item.baseUrl || GetLocalStorage('BASEURL'),
      })),
    )
    // 扩展属性
    setFieldList(
      formdata.fieldList?.map((item: any) => ({
        ...item,
      })),
    )
    changeItemList(formatFieldForDetail(formdata.projectValueInfoList))
    let remakers: string = formdata.remark ?? ''
    if (formdata.testingFee) {
      remakers = remakers.replace(
        getFeeText('testingFee', formdata.testingFee),
        '',
      )
    }
    if (formdata.packingExpense) {
      remakers = remakers.replace(
        getFeeText('packingFee', formdata.packingExpense),
        '',
      )
    }

    return {
      ...formdata,
      productType: formdata.srmProductType, // 物料类型
      name: formdata.name, // 物料名称
      tempCode: formdata.code, // 编码
      cateName: formdata.cateName, // 类目名
      fourthCateMdmId: formdata.fourthCateMdmId || formdata.cateMdmId, // 类目ID
      brand: `${formdata.brandNameCn}/${formdata.brandNameEn}`, // 品牌
      brandMdmId: formdata.brandMdmId, // 品牌ID
      brandNameCn: formdata.brandNameCn, // 品牌中文名
      brandNameEn: formdata.brandNameEn, // 品牌英文名
      spec: formdata.model, // 型号规格
      baseunitName: formdata.basicUnitName + '/' + formdata.basicUnit, // 基本单位名称
      baseunit: formdata.basicUnit, // 基本单位
      grossweight: formdata.grossWeight, // 毛重
      netweight: formdata.netWeight, // 净重（千克）
      marketprice: formatterPrice(formdata.marketPrice), // 市场价
      mallprice: formatterPrice(formdata.supplyPrice), // 参考供货价
      freight: formdata.isTransferPriceFreightIncluded, // 含运费
      barCode: formdata.barCode, // 条形码
      deliveryday:
        formdata.deliveryDay === '详询客服' ? '' : formdata.deliveryDay, // 发货期
      deliveryDate: formdata.deliveryDay,
      orderQuantity: formdata.moq, // 起订量
      size1: formdata.length, // 长（mm）
      size2: formdata.width, // 宽（mm）
      size3: formdata.height, // 高（mm）
      volume: formdata.volume, // 体积
      remakers, // 描述
      id: formdata.id,
      productMdmId: formdata.productMdmId,
      cateMdmId: formdata.cateMdmId,
      isAssessing: formdata.isAssessing,
      picMatch: formdata.pictureRelationship, // 图片匹配度
      packingExpense: formdata.packingExpense, // 安装费
      testingFee: formdata.testingFee, // 检测费
      externalLinks: toExternalLinkPayload(externalLinkList), // 外部链接
      haltProduction: formdata.isDelisting, // 停产
      taxCategoryCode: formdata.taxCategoryCode, // 税收分类编码
      taxCategoryCodeName: formdata.taxCategoryName, // 税收分类名称
      taxCategoryRate: formdata.taxCategoryRate, // 税率字段 税率
      abbreviation: formdata.taxCategoryAbbr, // 简称
    }
  }

  // 获取基础表单数据（提交）
  const getformatFormFields = async () => {
    // 同时校验主表单和平台表单
    const [formValue, platformFormValue] = await Promise.all([
      form.validateFields(),
      platform_form.validateFields(),
    ])
    // 拓展属性
    const expands = getFieldList()
    // 主图
    const picUrlList = getPicListString()
    // 详情图
    const detailPicUrlList = getDetailPicListString()
    // 产品资料
    const productFiles = getFileListString()
    // 检测报告
    const detectionFiles = getdetectionListString()
    // 质量证明
    const qualityFiles = getQualityList()
    const des = `${getFeeText('testingFee', formValue.testingFee)}${getFeeText(
      'packingFee',
      formValue.packingExpense,
    )}${formValue.remakers ?? ''}`
    return {
      ...pick(formValue, ['picMatch']),
      supplierId: getSupplierId(),
      expands: expands, // 拓展属性
      mainPictures: picUrlList, // 主图
      detailedPictures: detailPicUrlList, // 详情图
      productLiteratures: productFiles, // 产品资料
      reports: detectionFiles, // 检测报告
      certificateOfQualitys: qualityFiles, // 质量证明
      tempCode: formValue.tempCode, // 临时编码
      name: formValue.name, // 商品名称
      cateName: formValue.cateName, // 类目名称
      fourthCateMdmId: formValue.fourthCateMdmId, // 四级类目ID
      brand: formValue.brand, // 品牌
      brandMdmId: formValue.brandMdmId,
      brandNameCn: formValue.brandNameCn || formValue.brand.split('/')[0],
      brandNameEn: formValue.brandNameEn || formValue.brand.split('/')[1],
      model: formValue.spec, // 规格型号
      basicUnit: formValue.baseunit, // 基本单位
      basicUnitName: formValue.baseunitName?.split('/')[0], // 基本单位
      grossWeight: formValue.grossweight, // 毛重
      netWeight: formValue.netweight ? formValue.netweight : '', // 净重（千克）
      marketPrice: formValue.marketprice, // 市场价
      purchasePrice: formValue.mallprice, // 参考供货价
      freight: formValue.freight, // 是否包邮
      barCode: formValue.barCode, // 条形码
      deliveryDate: hasDelivery ? '详询客服' : formValue.deliveryday, // 发货期 hasDelivery为true是详询客服
      orderQuantity: formValue.orderQuantity, // 起订量
      length: formValue.size1, // 长（mm）
      width: formValue.size2, // 宽（mm）
      height: formValue.size3, // 高（mm）
      volume: formValue.volume, // 体积
      des, // 描述
      isMultipleOrder: formValue.isMultipleOrder,
      id: formValue.id ?? '',
      cateMdmId: formValue.cateMdmId ?? '',
      productMdmId: formValue.productMdmId ?? '',
      testingFee: formValue.testingFee, // 含检测费
      packingExpense: formValue.packingExpense, // 含安装费
      haltProduction: formValue.haltProduction, // 停产
      pictureRelationship: formValue.picMatch, // 图片关系
      externalLinks: toExternalLinkPayload(externalLinkList), // 外部链接
      platformDetails: formatFieldForSubmit(itemsList), // 项目信息
      productType: formValue.productType,
      taxCategoryCode: formValue.taxCategoryCode, // 税收分类编码
      taxCategoryName: formValue.taxCategoryCodeName, // 税收分类名称
      taxCategoryRate: formValue.taxCategoryRate, // 税率字段 税率
      taxCategoryAbbr: formValue.abbreviation, // 简称
    }
  }

  const onChangeBrandSale = (params: string) => {
    dispatch(changeMallSaleAction(params === '0' ? true : false))
  }
  // 获取临时编码
  const getTempCode = async (preCode?: string) => {
    const res = await GET_MARKUP_TEMPCODE({
      supplierCode: GetLocalStorage('SUPPLIER_MDM_CODE'),
      supplierId: getSupplierId(),
      preCode,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      dispatch(setErpCode(resData.tempCode))
    }
  }

  // 设置编码
  const setTempCodeFun = (code: string) => {
    dispatch(setErpCode(code))
  }

  // 主图数据处理
  const getPicListString = () => {
    return [...pictures]
  }

  // 详情图数据处理
  const getDetailPicListString = () => {
    return [...detailPic]
  }

  // 产品资料数据处理
  const getFileListString = () => {
    return [...productFileList]
  }

  // 检查报告数据处理
  const getdetectionListString = () => {
    return [...detectionFileList]
  }

  // 获取质量证明url数组
  const getQualityList = () => {
    return [...qualityList]
  }

  // 改变发货期
  const onChangeDelivery = (param: boolean) => {
    dispatch(changeDeliveryAction(param))
  }

  // 基本单位是否禁用
  const changeUnitDisabled = (val: boolean) => {
    dispatch(setUnitDisabledAction(val))
  }

  // 物料类型
  const setMaterialType = (val: MaterialType) => {
    dispatch(setMaterialTypeAction(val))
  }

  // 项目字段
  const changeItemList = (val: PlatformField[]) => {
    dispatch(setItemListAction(val))
  }

  // 提交时格式化项目字段参数
  const formatFieldForSubmit = (list: PlatformField[]) =>
    list.map((item) => ({
      platformName: item.name,
      platformCode: item.code,
      fieldKeyAndValue: item.itemFields.map((child) => {
        const fieldValue = platform_form.getFieldValue(
          `${item.code}_${child.fieldKey}`,
        )
        return {
          fieldKey: child.fieldKey,
          fieldName: child.fieldName,
          fieldValue:
            child.controlType === '5'
              ? (fieldValue as string[])?.join(',')
              : fieldValue,
          rangeList: child.rangeList,
          require: child.require,
          controlType: child.controlType,
        }
      }),
    }))

  // 回填时格式化项目字段
  const formatFieldForDetail = (list: any[]): PlatformField[] =>
    list.map((item) => ({
      name: item.platformName,
      code: item.platformCode,
      itemFields: item.fieldKeyAndValue.map((item: any) => ({
        ...item,
        fieldValue: item.fieldValue === 'null' ? undefined : item.fieldValue,
        fieldValueName:
          item.fieldValueName === 'null' ? undefined : item.fieldValueName,
      })),
      pushRequirements: item.pushRequirements,
    }))

  // 获取GH03类目信息
  // const getGH03Category = async () => {
  //   const res: any = await GET_GH03_CATEGORY()
  //   dispatchRedux(
  //     setLocalCategoryInfoAction({
  //       name: res[0]?.name,
  //       id: res[0]?.id,
  //     }),
  //   )
  //   // 默认值
  //   if (!materialType) {
  //     const defaultMaterialType = cooperateType === '3' ? '2' : cooperateType
  //     defaultMaterialType === '2' &&
  //       form.setFieldsValue({
  //         cateName: res[0]?.name,
  //         fourthCateMdmId: res[0]?.id,
  //       })
  //   }
  // }

  // 快捷拾取弹框打开按钮
  const handleOpenExtractModal = (type: string) => {
    dispatch(setGoShibeiType(type))
    dispatch(setExtractVisible(true))
  }

  // 快捷拾取结果页弹框取消按钮
  const closeExtractModal = () => {
    dispatch(setExtractVisible(false))
  }

  const clickCopy = () => {
    const supRoute = userRouter[1].url
    const formData = form.getFieldsValue()
    const platform = platform_form.getFieldsValue()
    history.replace({
      pathname: `${supRoute}/addgoods`,
      state: {
        type: 'copy',
        platform,
        formData,
        pageState: state,
        externalLinkData: externalLinkList,
      },
    })
    dispatchPageCache(delModuleDataAction(`${supRoute}/addgoods`))
  }

  // 新增、修改、重推提交时，校验平台要求必传的资质图片类型
  const checkRequiredQualityTypes = () => {
    if (
      !reportTypeEnum.isLabelsMatchValue(
        ['商品新增', '商品修改', '商品重推'],
        routerParams.submissionType,
      )
    ) {
      return true
    }
    const missing = getMissingQualityTypeLabels([projectCode], qualityDataList)
    if (missing.length) {
      message.warning(`请上传资质图片：${missing.join('、')}`)
      return false
    }
    return true
  }

  // 点击保存
  async function onSave(type: 'save' | 'submit') {
    try {
      // 格式化表单数据
      const [value, formValue] = await Promise.all([
        platform_form.validateFields(),
        form.validateFields(),
      ])
      if (qualityDataList.length > 10) {
        message.warning('资质图片最多上传10张')
        return
      }
      if (type === 'submit' && !checkRequiredQualityTypes()) {
        return
      }
      message.loading('保存中', 0)
      // @ts-ignore
      const data = extendedInfoList.map((child) => {
        const fieldValue = value[`${projectCode}_${child.fieldKey}`]
        const fieldValueName = value[`${projectCode}_${child.fieldKey}_name`]

        const fieldValueData =
          child.controlType === '5'
            ? (fieldValue as string[])?.join(',')
            : fieldValue
        return {
          ...child,
          fieldValue:
            child.relateField && fieldValueData === undefined
              ? 'null'
              : fieldValueData,
          fieldValueName:
            child.relateField &&
            (fieldValueName === undefined || fieldValueData === 'null')
              ? 'null'
              : fieldValueName || fieldValueData,
        }
      })
      const params = {
        id: routerParams.id,
        extendedInfoList: data,
        attributesJson: {},
        materialAptitudeFileList: qualityDataList,
        // 资料附件（12 类 docType 资质）
        qualDocFileList,
        saleJobNumber: formValue.saleJobNumber,
        saleName: formValue.saleName,
        saleRemark: formValue.saleRemark,
      }
      if (type === 'save') {
        const resData = await POST_SAVE_MATERIAL_REPORT(params)
        if (resData.code === 0) {
          message.success('已成功')
          reportProjectCategoryAdoptions()
          // 关闭页面，回退路由
          onClickClose()
        } else {
          message.destroy()
        }
      } else {
        preCheckSubmitForSave(params)
      }
    } catch (errorInfo) {
      const error = (errorInfo as any).errorFields[0].errors[0]
      message.warning(error)
      const errorname = (errorInfo as any).errorFields[0].name
      // 返回报错信息，滚动到第一个报错的位置
      form.scrollToField(errorname.toString(), { behavior: 'smooth' })
    }
  }
  const onCommitSaveMaterialReport = async (params: any) => {
    const resData = await POST_SUMBIT_MATERIAL_REPORT(params)
    if (resData.code === 0) {
      message.success('已成功')
      reportProjectCategoryAdoptions()
      // 关闭页面，回退路由
      onClickClose()
    } else {
      message.destroy()
    }
  }

  const setQualityDataList = (data: QualityList[]) => {
    dispatch(setQualityDataListAction(data))
  }

  // 改变资料附件
  const onChangeAptitude = (list: AptitudeFile[]) => {
    dispatch(setQualDocFileListAction(list))
  }
  // 点击保存
  async function onSaveAndSumbit() {
    try {
      // 格式化表单数据
      const [value, formValue] = await Promise.all([
        platform_form.validateFields(),
        form.validateFields(),
      ])
      if (qualityDataList.length > 10) {
        message.warning('资质图片最多上传10张')
        return
      }
      if (!checkRequiredQualityTypes()) {
        return
      }
      message.loading('保存中', 0)
      // @ts-ignore
      const data = extendedInfoList.map((child) => {
        const fieldValue = value[`${projectCode}_${child.fieldKey}`]
        const fieldValueName = value[`${projectCode}_${child.fieldKey}_name`]

        const fieldValueData =
          child.controlType === '5'
            ? (fieldValue as string[])?.join(',')
            : fieldValue

        return {
          ...child,
          fieldValue:
            child.relateField && fieldValueData === undefined
              ? 'null'
              : fieldValueData,
          fieldValueName:
            child.relateField &&
            (fieldValueName === undefined || fieldValueData === 'null')
              ? 'null'
              : fieldValueName || fieldValueData,
        }
      })
      const formData = form.getFieldsValue()
      const reportFieldValues = buildReportFieldValues(
        reportFieldConfigList,
        value,
      )
      const params = {
        projectCode: routerParams.platformCode, // 项目code
        projectName: formData.projectName, // 项目名称
        reportType: routerParams.submissionType, // 提报类型
        extendedInfoList: data, // 扩展信息JSON
        //资质图片类文件
        materialAptitudeFileList: qualityDataList,
        // 资料附件（12 类 docType 资质）
        qualDocFileList,
        materialCode: formData.materialCode, // 物料编码（商品编码）
        materialId: formData.materialId, // 物料ID
        materialName: formData.materialName, // 物料名称
        supplierId: getSupplierId(), // 供应商ID
        supplierName: GetLocalStorage('HOME_DATA')?.enterpriseName, // 供应商名称
        attributesJson: {},
        saleJobNumber: formValue.saleJobNumber,
        saleName: formValue.saleName,
        saleRemark: formValue.saleRemark,
        reportFieldValues,
      }
      preCheckSubmit(params)
    } catch (errorInfo) {
      const error = (errorInfo as any).errorFields[0].errors[0]
      message.warning(error)
      const errorname = (errorInfo as any).errorFields[0].name
      // 返回报错信息，滚动到第一个报错的位置
      form.scrollToField(errorname.toString(), { behavior: 'smooth' })
    }
  }

  const onCommitMaterialReport = async (params: any) => {
    const resData = await POST_SUBMIT_MATERIAL_REPORT_NEW(params)
    if (resData.code === 0) {
      message.success('已成功')
      reportProjectCategoryAdoptions()
      // 关闭页面，回退路由
      onClickClose()
    } else {
      message.destroy()
    }
  }

  // 暂存
  const onStorage = async () => {
    const formData = form.getFieldsValue()
    const platform_formData = serializeFormValuesForStorage(
      platform_form.getFieldsValue(),
    )

    const data = {
      formData,
      platform_formData,
      state,
    }

    const params = {
      projectCode: routerParams.platformCode,
      materialCode: routerParams.productCode,
      storageInfoJson: JSON.stringify(data),
    }

    const res = await POST_STORAGE_NEW_MATERIAL(params)

    if (res.code === 0) {
      message.success('已暂存')
      reportProjectCategoryAdoptions()
    } else {
      message.error(res.msg)
    }
  }

  // 解析动态字段下拉选项：优先 fieldEnumValueList，兜底 controlRuleJson.options
  const parseReportFieldOptions = (field: ReportFieldConfigVO) => {
    if (field.fieldEnumValueList?.length) return field.fieldEnumValueList
    try {
      const rule = field.controlRuleJson
        ? JSON.parse(field.controlRuleJson)
        : null
      if (Array.isArray(rule?.options)) return rule.options
    } catch (error) {
      return []
    }
    return []
  }

  // 根据 ProjectValidationInfo 的配置 + 表单值组装 submitNew 所需 reportFieldValues
  const buildReportFieldValues = (
    configList: ReportFieldConfigVO[],
    platformFormValue: Record<string, any>,
  ) =>
    configList
      ?.map((field) => {
        if (!field.fieldKey) return null
        const fieldName = `reportField_${field.fieldKey}`
        const raw = platformFormValue[fieldName]
        if (
          raw === undefined ||
          raw === null ||
          raw === '' ||
          (Array.isArray(raw) && raw.length === 0)
        ) {
          return null
        }

        let fieldValue = ''
        let fieldValueLabel = ''
        if (field.controlType === '6' && Array.isArray(raw)) {
          fieldValue = raw.join(',')
          const options = parseReportFieldOptions(field)
          fieldValueLabel = raw
            .map(
              (item) =>
                options.find(
                  (opt: { label: string; value: string }) => opt.value === item,
                )?.label || item,
            )
            .join(',')
        } else if (field.controlType === '5') {
          fieldValue = String(raw)
          const options = parseReportFieldOptions(field)
          fieldValueLabel =
            options.find(
              (opt: { label: string; value: string }) => opt.value === raw,
            )?.label || fieldValue
        } else if (field.controlType === '4' && moment.isMoment(raw)) {
          let rule: Record<string, any> = {}
          try {
            rule = field.controlRuleJson
              ? JSON.parse(field.controlRuleJson)
              : {}
          } catch {
            /* controlRuleJson 非法，使用默认格式 */
          }
          const format = rule?.format || 'YYYY-MM-DD'
          fieldValue = raw.format(format)
          fieldValueLabel = fieldValue
        } else {
          fieldValue = String(raw)
          fieldValueLabel = fieldValue
        }

        return {
          configId: field.id,
          fieldKey: field.fieldKey,
          fieldValue,
          fieldValueLabel,
        }
      })
      .filter(Boolean)

  // 设置预审错误信息
  const setPreCheckErrors = (errors: PreCheckErrors) => {
    dispatch(setPreCheckErrorsAction(errors))
  }

  // 同步 submitType state 到 ref
  useEffect(() => {
    submitTypeRef.current = submitType
  }, [submitType])

  // 设置提交类型
  const setSubmitType = (type: 'new' | 'old') => {
    submitTypeRef.current = type // 立即更新 ref，确保后续调用能获取到最新值
    dispatch(setSubmitTypeAction(type))
  }

  // 提交数据（预审成功后调用 - 根据类型选择不同的提交方式）
  const handleSubmit = async (params: any) => {
    // 使用 ref 获取最新的 submitType 值，避免闭包问题
    const currentSubmitType = submitTypeRef.current
    if (currentSubmitType === 'new') {
      await onCommitMaterialReport(params)
    } else {
      await onCommitSaveMaterialReport(params)
    }
  }

  // 使用预审 Hook（统一处理新接口和旧接口）
  const { executePreCheck, PreCheckModalComponent, submitting } = usePreCheck({
    form,
    onSubmit: handleSubmit,
    onModify: (errors) => {
      setPreCheckErrors(errors)
    },
  })

  // 提交数据（带预审 - 新接口）
  const preCheckSubmit = async (params: any) => {
    setPreCheckErrors({})
    setSubmitType('new')
    await executePreCheck(
      params,
      preReviewOfMaterialsTypeEnum.getValueByLabel('提报驳回更新') || '',
    )
  }

  // 提交数据（带预审 - 旧接口，用于 onSave('submit')）
  const preCheckSubmitForSave = async (params: any) => {
    setPreCheckErrors({})
    setSubmitType('old')
    await executePreCheck(
      params,
      preReviewOfMaterialsTypeEnum.getValueByLabel('单条提报') || '',
    )
  }
  return {
    usehookstate: state,
    form,
    platform_form,
    brandIsSale,
    changeList,
    dispatchhook: dispatch,
    setChangeList,
    onFieldsChange,
    onChangePic,
    onChangeFile,
    onChangeDetectionfile,
    onChangeQualityfile,
    onChangeDetailPic,
    onChangeFieldlist,
    onChangeUploadPicCode,
    onChangeCate,
    onChangeBrandSale,
    setFieldList,
    getFieldList,
    onClickClose,
    onClickRecord,
    onCancelrecord,
    onExpansion,
    onChangeLoading,
    formatFormFields,
    getformatFormFields,
    reloaddata,
    code,
    tempCode,
    setTempCodeFun,
    onChangeDelivery,
    changeUnitDisabled,
    getTempCode,
    setMaterialType,
    changeItemList,
    handleOpenExtractModal,
    closeExtractModal,
    clickCopy,
    externalLinkList,
    setExternalLinkList,
    onSave,
    onStorage,
    onSaveAndSumbit,
    setQualityDataList,
    qualDocFileList,
    onChangeAptitude,
    frontendHintText,
    preCheckErrors,
    submitType,
    onCommitMaterialReport,
    onCommitSaveMaterialReport,
    setPreCheckErrors,
    setSubmitType,
    setReportFieldConfigList,
    PreCheckModalComponent,
    relateFieldKeySet,
    handleRelateFieldBlur,
    relateFieldCalcLoading,
    submitting,
  }
}

export default useHook

// 表单各数值类型
export interface FormFields {
  owner?: string // 货主
  ownerName?: string // 货主名称
  tempCode?: string // 临时编码
  name?: string // 商品名称
  childId?: string // 物料id 标识所有用到form的地方此次操作为新增或者编辑或者审核等
  // material_state?: string; //物料状态
  dataNature?: string // 物料性质
  // 业务组织
  create_code?: string // 创建组织编码
  consignor?: string // 货主
  consignorName?: string // 货主名称
  // create_user?: string; //创建人
  use_organ?: string[] // 使用组织
  // 身份属性
  code?: string // 商品编码
  barCode?: string // 条形码
  remakers?: string // 描述
  // name?: string; //商品名称
  mncode?: string // 助记码
  spec?: string // 型号规格
  // 辅助属性
  catoyName?: string // 所属类目
  catoyid?: string // 所属类目id
  invencategory?: string // 存货类别
  invencategoryName?: string // 存货类别名称
  inremakers?: string // 内部备注
  materialbrand?: string // 物料品牌
  materialbrandName?: string // 物料品牌名称
  materialbrandCode?: string // 物料品牌code
  materialbrandSale?: string // 品牌是否可售

  baseunit?: string // 基本单位
  baseunitName?: string // 基本单位名称
  deliveryday?: string // 发货日(天)
  // 财务考核属性
  procurement?: string // 采购员
  procurementName?: string // 采购员名称
  procurementDept?: string // 采购部门
  procurementDeptName?: string // 采购部门名称
  examinationType?: string // 考核类别
  examinationTypeName?: string // 考核类别名称
  examinationPerson?: string // 考核员
  examinationPersonName?: string // 考核员名称

  // 价格属性
  marketprice?: string // 市场价
  mallprice?: string // 商城价
  transferprice?: string // 调拨价
  // 控制属性
  onshelf?: '1' | '0' // 商城上架
  mallsales?: '1' | '0' // 商城可售不可售
  allowprocurement?: '1' | '0' // 允许采购
  inventory?: '1' | '0' // 允许库存
  outcommit?: '1' | '0' // 允许委外
  sales?: '1' | '0' // 允许销售
  product?: '1' | '0' // 允许生产
  assets?: '1' | '0' // 允许资产
  isFreeShipping?: '1' | '0' // 是否包邮
  isOverLength?: '1' | '0' // 是否超长
  // 重量属性
  grossweight?: string // 毛重(千克)
  netweight?: string // 净重(千克)
  // 尺寸属性
  size1?: string // 长
  size2?: string // 宽
  size3?: string // 高
  volume?: string // 体积
  // 库存属性

  materialattr?: string // 物料属性
  materialattrName?: string // 物料属性 名称
  taxtype?: string // 税分类
  taxtypeName?: string // 税分类 名称
  defaulttax?: string // 默认税率
  defaulttaxName?: string // 默认税率 名称
  salesunit?: string // 销售单位
  salesunitName?: string // 销售单位 名称
  salesvaluaunit?: string // 销售计价单位
  salesvaluaunitName?: string // 销售计价单位 名称
  procureunit?: string // 采购单位
  procureunitName?: string // 采购单位 名称
  procurevaluaunit?: string // 采购计价单位
  procurevaluaunitName?: string // 采购计价单位 名称
  inventoryunit?: string // 库存单位
  inventoryunitName?: string // 库存单位 名称
  costunit?: string // 成本单位
  costunitName?: string // 成本单位 名称
  rulestype?: string // 批号编码规则
  rulestypeName?: string // 批号编码规则 名称
  canBeMainProduct?: '1' | '0' // 可为主产品
  batchmanage?: '1' | '0' // 启用批号管理
  currency?: string // 币别
  onlocklib?: '1' | '0' // 允许锁库
  // 销售属性
  onreturn?: '1' | '0' // 允许退货
  // 采购属性
  onreturnmaterial?: '1' | '0' // 允许退料
  // 物料维度
  pricestate?: '1' | '0' // 影响价格
  coststate?: '1' | '0' // 影响成本
  exemptPostage?: '1' | '0' // 包邮
  overlength?: '1' | '0' // 超长
  // 拓展属性
  level?: string // 物料等级
  // 主图
  picMatch?: string // 图片匹配度
  // 原始图是否可用
  orgpic?: string // 是否可用
  freight?: string // 调拨价是否包含运费
  productManager?: string // 产品经理
  productManagerId?: string // 产品经理id
  [x: string]: any
}
